import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as MuiToggleButton } from '@material-ui/lab/ToggleButton';
import { useStyles } from './ToogleButton.styles';
export var ToggleButton = React.forwardRef(function (props, ref) {
    var variant = props.variant, rest = __rest(props, ["variant"]);
    var classes = useStyles(props);
    return (React.createElement(MuiToggleButton, __assign({ ref: ref }, rest, { classes: {
            root: classes.root,
            selected: classes.selected,
        } })));
});
export default ToggleButton;
//# sourceMappingURL=ToggleButton.js.map